<template>
  <div class="login-page page-padding-top">
    <div class="login-top flex-center-between" v-if="!hideTopBar">
     <div class="back">
        <Icon name="arrow-left" @click="back" size="20" color="#353945"></Icon>
      </div>
      <span class="page-title">{{$t(`resetPassword.title${step}`)}}</span>
      <span class="right"></span>
    </div>


    <div class="login-form">

      <!-- <div class="tabs long" v-show="step == 1">
        <div class="tab" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{i18n.t('resetPassword.tab')}}</div>
        <div class="tab" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{i18n.t('resetPassword.tab2')}}</div>
      </div> -->

      <div class="form-label" v-if="tabIndex == 1 && step == 1">{{$t('register.label2')}}</div>
      <div class="form-item  flex-center" v-show="tabIndex == 1 && step == 1" >
        <div class="input"> 
          <input type="text" v-model="form.username"   :placeholder="i18n.t('resetPassword.labelPlaceholder1')">
        </div>
      </div>

      <div class="form-label" v-if="tabIndex == 2 && step == 1">{{$t('register.label3')}}</div>
      <div class="form-item  flex-center" v-if="tabIndex == 2 && step == 1">
        <div class="pre flex-center-start" @click="changePre">
          {{phonePre}}
          &nbsp;&nbsp;
          <icon name="arrow-down" size="14" color="#353945"></icon>
        </div>
        <div class="flex-1">
          <div class="input clear"> 
            <input type="tel" v-model="form.phone" :placeholder="i18n.t('resetPassword.labelPlaceholder8')">
          </div>
        </div>
      </div>

      <div class="form-label" v-show="step == 2 ">
        {{$t(`register.label6_${tabIndex}`)}}
      </div>

      <div class="form-item clear flex-center" v-show="step == 2" >
        <div class="input long"> 
          <input type="tel"  v-model="form.code"  :placeholder="i18n.t('register.labelPlaceholder2')">
        </div>
        <div class="adot long">
          <span class="gray" v-if="isDisabled">{{$t('register.send')}}({{timeCount}})</span>
          <span v-else @click="resend">{{$t('register.btn1')}}</span>
        </div>
      </div>

      <div class="form-label" v-show="step == 3">
        {{$t('resetPassword.label3')}}
      </div>

      <div class="form-item flex-center" v-if="step == 3" >
        <div class="flex-1" @click="changeType">
          <div class="input select  flex-center-between" :class="form.cardTypeName ? 'active' : ''">
            <span>{{form.cardTypeName || i18n.t('resetPassword.labelPlaceholder5')}}</span>
            <img :src="rightUrl" alt="">
          </div>
        </div>
      </div>

      <div class="form-label" v-show="step == 3">
        {{$t('resetPassword.label4')}}
      </div>

      <div class="form-item flex-center" v-if="step == 3" >
        <div class="flex-1">
          <div class="input clear"> 
            <input type="text" v-model="form.cardNo" :placeholder="i18n.t('resetPassword.labelPlaceholder9')">
          </div>
        </div>
      </div>

      <div class="form-label" v-show="step == 4">
        {{$t('resetPassword.label1')}}
      </div>

      <div class="form-item flex-center" v-if="step == 4" >
        <div class="input"> 
          <input :type="showPassword ? 'text' : 'password'" @input="changePassword" v-model="form.password" :placeholder="i18n.t('resetPassword.labelPlaceholder2')">
        </div>
        <div class="adot" @click="changeShowPassword">
          <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>
      


      <div class="password-auth" v-show="showPasswordAuth">
        <div class="auth-line flex-center-start" :class="passwordAuthList.indexOf(0) > -1 ? 'green' : ''"> 
          <img :src="passwordAuthList.indexOf(0) > -1 ? checkUrl2 : checkUrl" alt="">
          <span>{{i18n.t('register.passwordMinLength')}}</span>
        </div>
      </div>

      <div class="form-label" v-show="step == 4">
        {{$t('resetPassword.label2')}}
      </div>

      <div class="form-item flex-center" v-if="step == 4" >
        <div class="input"> 
          <input :type="showPassword2 ? 'text' : 'password'" @input="changeConfirmPassword" v-model="form.password2" :placeholder="i18n.t('resetPassword.labelPlaceholder3')">
        </div>
        <div class="adot" @click="changeshowPassword2">
          <img :src="showPassword2 ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>


      
    </div>

    <Button class="login-btn" @click="submit" :disabled="!btnDisabled">{{i18n.t(`resetPassword.btn${step}`)}}</Button>

    <Popup v-model:show="showPopup" position="bottom">
			<div class="country-list" >
				<div class="title flex-center-between">
          <icon name="arrow-left" size="20" color="#000" @click="cancel"></icon>
          <span>{{i18n.t('login.labelPlaceholder3')}}</span>
          <span></span>
        </div>
        <div class="search-list flex-center-between">
          <div class="flex-center">
            <img :src="searchUrl" alt="">
            <input type="text" v-model="keyword" :placeholder="i18n.t('register.labelPlaceholder7')" @input="searchCountry" @change="searchCountry">
          </div>
        </div>
        <div class="group-list login" v-for="(item, i) in countryList" :key="i">
          <div class="country-title" :id="item.id" v-if="item.id != 'common' && !keyword">{{item.title}}</div>
          <div class="country-title flex-center-start" v-if="item.id == 'common' && !keyword">
            <img :src="starUrl" alt="">
            {{$t('common.use')}}
          </div>
          <div class="list flex-center-start" :class="child.key == phonePre ? 'active' : ''" v-for="(child, index) in item.children" :key="index" @click.stop="chooseCountry(child)">
            <div class="img-box flex-center">
              <img :src="child.icon" alt="">
              <span>{{getCountryName(child.title)}}</span>
            </div>
            <div>
              {{child.key}}
            </div>
          </div>
        </div>
        <div class="fast-link">
          <div class="link" v-for="(item, i) in linkList" :key="i" @click="toFastPage(item)">
            {{item.title}}
          </div>
        </div>
			</div>
    </Popup>

     <Popup v-model:show="showPicker" position="bottom">
        <Picker
          :columns="typeList"
          valueKey="text"
          show-toolbar
          :confirm-button-text="$t('common.ensure')"
          :cancel-button-text="$t('common.cancel')"
          @confirm="chooseType"
          @cancel="cancel"
        ></Picker>
     </Popup>
  </div>
</template>
<script>
  import { Button, Popup, Icon, Picker } from 'vant'
  import { resetPassword, sendCode, checkEmailCode, sendSms, checkPhoneCode } from '@/api/login'
  import { setToken, setUser, setUserId } from '@/utils/auth'
  import { normalizePassword, isPasswordLongEnough, validatePasswordPair } from '@/utils/passwordRules'
  export default {
    components: {
      Button,
      Popup,
      Icon,
      Picker
    },
    data() {
      return {
        step: 1,
        form: {
          username: '',
          phone: '',
          password: '',
          password2: '',
          code: '',
          inviteCode: '',
          cardType: '',
          cardTypeName: '',
          cardNo: ''
        },
        backUrl: require('../../assets/imgs/icon-back.png'),
        starUrl: require('../../assets/imgs/icon-star.png'),
        closeUrl: require('../../assets/imgs/icon-close.png'),
        emailUrl: require('../../assets/imgs/icon-email2.png'),
        passwordUrl: require('../../assets/imgs/icon-password.png'),
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        checkUrl: require('../../assets/imgs/icon-check.png'),
        checkUrl2: require('../../assets/imgs/icon-check2.png'),
        warningUrl: require('../../assets/imgs/icon-warning.png'),
        phoneUrl: require('../../assets/imgs/icon-phone2.png'),
        searchUrl: require('../../assets/imgs/icon-search.png'),
        rightUrl:require('../../assets/imgs/icon-arrow-down3.png'),
        showPassword: false,
        showPassword2: false,
        activeIndex: 1,
        isDisabled: false,
        sendTime: '',
        checkRole: false,
        showInvite: true,
        showPasswordAuth: false,
        passwordAuthList: [],
        phonePre: '+86',
        tabIndex: 1,
        showPopup: false,
        countryList: [],
        keyword: '',
        linkList: [],
        showPicker: false,
        typeList: [
          {
            value: '1',
            text: '身份证'
          },
          {
            value: '2',
            text: '护照'
          },
          {
            value: '3',
            text: '驾驶证'
          },
        ],
      }
    },
    computed: {
      timeCount() {
        return this.sendTime + 's'
      },
      btnDisabled() {
        if (this.step == 1) {
          return this.form.username || this.form.phone
        } else if (this.step == 2) {
          return this.form.code
        } else if (this.step == 3) {
          return this.form.cardType && this.form.cardNo
        } else {
          return isPasswordLongEnough(this.form.password) && !!normalizePassword(this.form.password2)
        }
      },
      countryListBak() {
        return this.$store.state.countryList
      }
    },
    mounted() {
      this.countryList = [].concat(this.countryListBak)
      this.linkList = this.countryList.filter(v => {
        return v.id != 'common'
      })
    },
    methods: {
      changeTab(index) {
        if (this.step == 1) {
          this.tabIndex = index
        } 
      },
      back() {
        this.$router.go(-1)
      },
      toLogin() {
        this.$router.push({
          name: 'login'
        })
      },
      toSet() {
        if (!this.form.code ) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder2'))
          return
        }
        let form = new FormData()
        form.append('Code', this.form.code)
        form.append('Type', 2)
        if (this.tabIndex == 1) {
          form.append('Email', this.form.username)
          checkEmailCode(form).then(res => {
            if (res.code == 0) {
              this.step = 4
            } else {
              this.$toast.fail(res.msg)
            }
          })
        } else {
          form.append('Phone', this.phonePre + this.form.phone)
          checkPhoneCode(form).then(res => {
            if (res.code == 0) {
              this.step = 4
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }
      },
      submit() {
      
        if (this.step == 1) {
          if (this.tabIndex == 1) {
            this.sendEmail()
          } else { // 根据手机号，发送邮箱验证码
            this.sendPhoneSms()
          }
        } else if (this.step == 2) {
          this.toSet()
        } else if (this.step == 3) { // 验证证件
          this.step = 4
        } else {
          const validation = validatePasswordPair(this.form.password, this.form.password2)
          this.form.password = validation.password
          this.form.password2 = validation.confirmPassword

          if (!validation.password) {
            this.$toast.fail(this.i18n.t('resetPassword.labelPlaceholder2'))
            return
          }
          if (validation.isTooShort) {
            this.$toast.fail(this.i18n.t('register.passwordMinLength'))
            return
          }
          if (!validation.confirmPassword) {
            this.$toast.fail(this.i18n.t('resetPassword.labelPlaceholder3'))
            return
          }
          if (validation.isMismatch) {
            this.$toast.fail(this.i18n.t('register.passwordDiff'))
            return
          }

          let form = new FormData()
          if (this.tabIndex == 1) {
            form.append('Email', this.form.username)
          } else {
            form.append('Phone', this.phonePre + this.form.phone)
            form.append('CountryCode', this.phonePre)
          }
          form.append('Password', validation.password)
          form.append('Code', this.form.code)
          resetPassword(form).then(res => {
            if (res.code == 0) {
              this.$toast.success(this.i18n.t('resetPassword.success'))
              this.$router.push({
                name: 'login'
              })
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }
      },
      sendEmail() {
        if (!this.form.username) {
          this.$toast.fail(this.i18n.t('resetPassword.labelPlaceholder1'))
          return
        }
        let form = new FormData()
        form.append('Email', this.form.username)
        form.append('Type', 2)
        sendCode(form).then(res => {
          if (res.code == 0) {
            this.countDown(60)
            this.step = 2
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendPhoneSms() {
        if (!this.form.phone) {
         this.$toast.fail(this.i18n.t('resetPassword.labelPlaceholder8'))
          return
        }
        let form = new FormData()
        form.append('Phone', this.phonePre + this.form.phone)
        form.append('Type', 2)
        sendSms(form).then(res => {
          if (res.code == 0) {
            this.countDown(60)
            this.step = 2
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
      cancel() {
        this.showPopup = false
      },
      checkCodeSize() {
        let code = this.form.code + ''
        if (code.length > 6) {
          code = code.substring(0, 6)
          this.form.code = parseInt(code)
        }
      },
      getCodeActive(i) {
        let code = this.form.code + ''
        if (!code) {
          return i == this.activeIndex ? 'active' : ''
        }
        return i == code.length + 1 ? 'active' : ''
      },
      inputCode() {
        this.activeIndex = 1
        this.$refs.codeInput.focus()
      },
      getCodeStr(i) {
        let code = this.form.code + ''
        if (!code) {
          return ''
        }
        let str = code.substring(i - 1, i)
        return str
      },
      resend() {
        if (this.isDisabled) {
          return
        } else {
          this.sendEmail()
        }
      },
      changeRole() {
        this.checkRole = !this.checkRole
      },
      changeShowPassword() {
        this.showPassword = !this.showPassword
      },
      changeshowPassword2() {
        this.showPassword2 = !this.showPassword2
      },
      changeShowInvite() {
        this.showInvite = !this.showInvite
      },
      changePassword() {
        this.form.password = normalizePassword(this.form.password)
        this.showPasswordAuth = !!this.form.password
        let result = []

        if (isPasswordLongEnough(this.form.password)) {
          result.push(0)
        }

        this.passwordAuthList = result
      },
      changeConfirmPassword() {
        this.form.password2 = normalizePassword(this.form.password2)
      },
      changePre() {
        this.showPopup = true
      },
      chooseCountry(data) {
        this.phonePre = data.key
        this.showPopup = false
      },
      getCountryName(name) {
        if (!name) {
          return ''
        }
        let newName = ''
        newName = name.substring(0, name.indexOf('(') - 1)
        return newName
      },
      searchCountry() {
        if (this.keyword) {
          this.countryList = this.countryListBak.map(v => {
            let children = v.children.filter(val => {
              return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1  && v.id != 'common'
            })
            if (children.length > 0) {
              return {
                children: children
              }
            } else {
              return {
                children: []
              }
            }
          })
        } else {
          this.countryList = [].concat(this.countryListBak)
        }
      },
      toFastPage(key) {
        let dom = document.getElementById(key.id)
        let parentDom = document.querySelector('.country-list')
        if (dom && parentDom) {
          let domTop = dom.offsetTop
          parentDom.scrollTo({
            top: domTop - 124
          })
        }
      },
      chooseType(item) {
        this.form.cardType = item.value
        this.form.cardTypeName = item.text
        this.showPicker = false
      },
      changeType() {
        this.showPicker = true
      },
    },
  }
</script>
